<template>
  <div>
    <p class="lead mb-1 d-flex justify-content-between">
      <span>{{ action.node_data.question }}</span>
      <span class="small">{{ action.data.timestamp }}</span>
    </p>
    <div v-if="!action.data.answer" class="d-flex justify-content-between mt-2">
      <div class="d-flex flex-wrap gap-1">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 mb-1"
          v-for="(answer, idx) in action.node_data.answer_options"
          :key="idx"
          :disabled="terminated || validating"
          @click="$emit('answer-selected', { answer, action })"
        >
          {{ answer }}
        </b-button>
      </div>
    </div>
    <div v-else>{{ $t("action_plan.viewer.answer") }}: {{ action.data.answer }}</div>
  </div>
</template>

<script>
export default {
  props: {
    actionPlanLogUuid: String,
    action: Object,
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
};
</script>

<style></style>
